import React from 'react';
import { Link } from 'react-router-dom';
import BUILD_INFO from '../utils/buildInfo';
import { LEGAL_DOCUMENT_REGISTRY } from '../pages/legal/legalDocumentRegistry';

/**
 * Footer (signed-in surface).
 *
 * Legal-link section is registry-driven. Cookiebot renders its own persistent
 * Privacy Trigger globally, so the app does not duplicate it in this footer.
 */

const Footer = () => {
  // Show version in both production and staging
  const showVersion = ['production', 'staging'].includes(BUILD_INFO.environment);

  return (
    <footer className="bg-gray-100 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="text-sm text-gray-600">
            © {new Date().getFullYear()} 44 Laboratories, LLC, d.b.a. ADU Lab. All rights reserved.
            {showVersion && (
              <span
                className="ml-2 text-xs text-gray-400"
                title={`Build #${BUILD_INFO.runNumber} • Commit ${BUILD_INFO.commitSha.substring(0, 7)}`}
              >
                v{BUILD_INFO.version}.{BUILD_INFO.runNumber}
              </span>
            )}
          </div>

          <section aria-label="Legal" className="footer-legal-links">
            <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
              {LEGAL_DOCUMENT_REGISTRY.map((doc) => doc.slug === 'do-not-share' ? null : (
                <li key={doc.slug}>
                  <Link
                    to={doc.route}
                    className="text-gray-600 hover:text-gray-900 hover:underline"
                  >
                    {doc.title}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="mailto:support@44laboratories.com"
                  className="text-gray-600 hover:text-gray-900 hover:underline"
                >
                  Contact
                </a>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
